import React, { useEffect, useState } from 'react';
import './ContactMe.css';
import { ContactMe as IContactMe } from '../types';
import { getContactMe } from '../queries/getContactMe';

// ADDED imports for your new local icon components from the 'icons' subfolder
import EnvelopeIcon from './icons/EnvelopeIcon';
import PhoneAltIcon from './icons/PhoneIcon';
import CoffeeIcon from './icons/CoffeeIcon';
import LinkedinIcon from './icons/LinkedinIcon';


const ContactMe: React.FC = () => {
  const [userData, setUserData] = useState<IContactMe>();

  useEffect(() => {
    async function fetchUserData() {
      const data = await getContactMe();
      setUserData(data);
    }
    fetchUserData();
  }, []);

  if (!userData) return <div>Loading...</div>;

  return (
    <div className="contact-container">
      <div className="linkedin-badge-custom">
        <img src={userData.profilepicture.url} alt="Karan Balaji" className="badge-avatar" />
        <div className="badge-content">
          <h3 className="badge-name">{userData?.name}</h3>
          <p className="badge-title">{userData.title}</p>
          <p className="badge-description">
            {userData.summary}
          </p>
          <p className="badge-company">{userData.university}</p>
          <a
            href={userData.linkedinlink}
            target="_blank"
            rel="noopener noreferrer"
            className="badge-link"
          >
            {/* Replaced with local component */}
            <LinkedinIcon className="linkedin-icon" /> View Profile
          </a>
        </div>
      </div>
      <div className="contact-header">
        <p>I'm always up for a chat or a coffee! Feel free to reach out.</p>
      </div>
      <div className="contact-details">
        <div className="contact-item">
          {/* Replaced with local component */}
          <EnvelopeIcon className="contact-icon" />
          <a href={`mailto:${userData.email}`} className="contact-link">
            {userData.email}
          </a>
        </div>
        <div className="contact-item">
          {/* Replaced with local component */}
          <PhoneAltIcon className="contact-icon" />
          <a href={`tel:${userData.phonenumber}`} className="contact-link">
            {userData.phonenumber}
          </a>
        </div>
        <div className="contact-fun">
          <p>Or catch up over a coffee ☕</p>
          {/* Replaced with local component */}
          <CoffeeIcon className="coffee-icon" />
        </div>
      </div>
    </div>
  );
};

export default ContactMe;